__turbopack_context__.v({
  "body": "InscriptionBalanceModal-module__D1X25q__body",
  "paragraph": "InscriptionBalanceModal-module__D1X25q__paragraph",
  "root": "InscriptionBalanceModal-module__D1X25q__root",
});
